module.exports = __webpack_public_path__ + "static/415-effec74b6af521693f615752749d5b93.png";